"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Label = _styledComponents["default"].label.withConfig({
  displayName: "BestLabel__Label",
  componentId: "sc-125b7j1-0"
})(["color:#000000;font-weight:bold;font-size:0.875rem;margin-bottom:0;"]);

var Required = _styledComponents["default"].span.withConfig({
  displayName: "BestLabel__Required",
  componentId: "sc-125b7j1-1"
})(["color:", ";"], function (props) {
  return props.theme["mlb-red"];
});

var BestLabel = function BestLabel(_ref) {
  var htmlFor = _ref.htmlFor,
      required = _ref.required,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["htmlFor", "required", "children"]);

  return _react["default"].createElement(Label, _extends({
    htmlFor: htmlFor,
    name: htmlFor
  }, rest), children, " ", required ? _react["default"].createElement(Required, null, "*") : null);
};

BestLabel.propTypes = {
  htmlFor: _propTypes["default"].string.isRequired,
  required: _propTypes["default"].bool,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired
};
BestLabel.defaultProps = {
  required: false
};
var _default = BestLabel;
exports["default"] = _default;